/**
 * eventEditor.js
 * import axios for server calls
 * import Form is used for form fields and styling
 * import Button is the button field from react bootstrap
 * import Row and Col from react bootstrap for organizing display
 * import ErrorMessage for displaying error messages
 */
import React, {useEffect, useState} from "react";
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import "../../style/creationstyle.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ErrorMessage from "../Misc/ErrorMessage";

/**
 * @param getEvent = function to get call events
 * @param setEventEditorOpen = marks weither editor is editing or creating new event
 * @param close = function to close popup after completion
 */
function EventEditor({getEvent, setEventEditorOpen, editEventData, close}) {
    const[editorTitle, setEditorTitle] = useState("");
    const[editorName, setEditorName] = useState("");
    const[editorTime, setEditorTime] = useState("");
    const[editorLoc, setEditorLoc] = useState("");
    const[editorDes, setEditorDes] = useState("");
    const [editorNum, setEditorNum] = useState(1);
    const [editorVax, setEditorVax] = useState(false);
    const [fileName, setFileName] = useState("");
    const [images, setFile] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [missingTitle, setMissingTitle] = useState(null);
    const [missingDate, setMissingDate] = useState(null);
    const [missingTime, setMissingTime] = useState(null);
    const [missingLoc, setMissingLoc] = useState(null);
    const [missingDes, setMissingDes] = useState(null);
    const [missingFile, setMissingFile] = useState(null);
    const [missingInfo, setMissingInfo] = useState(false);
    const [desCount, setDesCount] = useState(0);
    const maxFileSize = 2000000;
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1; //January is 0 so need to add 1 to make it 1!
    var yyyy = today.getFullYear();
    if(dd<10){
        dd='0'+dd
    }    
    if(mm<10){
    mm='0'+mm
    }

    today = yyyy+'-'+mm+'-'+dd;

    /**
     * checks input file size and type
     */
    const onChangeFile = e => {
        //checks max file size
        if (e.target.files[0].size > maxFileSize) {
            setFileName("");
            setFile("");
            alert("file size is to Large. Please upload an image less than 2MB");
        } else if (!e.target.files[0].type.match(/image.*/)) {
            setErrorMessage("This file type is not supported. Please upload an image.");
            console.log(e.target.files[0].type);
            setFileName("");
            setFile("");
        }
        else {
        setFileName(e.target.files[0]);
        setFile(e.target.value);
        }
    };

    useEffect(() => {
        if(editEventData) {
            setEditorTitle(editEventData.title);
            setEditorName(editEventData.name);
            setEditorTime(editEventData.time);
            setEditorLoc(editEventData.location);
            setEditorDes(editEventData.description);
            setEditorNum(editEventData.rsvpLimit);
            setEditorVax(editEventData.vaxReq);
        }
    }, [editEventData]);
    /**
     * function saveEvent()
     * once event form is submited
     * function validates all input and then 
     * calls server to save new event
     */
    async function saveEvent(e) {
        e.preventDefault();
        var day = new Date();
        var hour = day.getHours();
        var mins = day.getMinutes();
        var time = hour+":"+mins;

        if(today === editorName){
            if(editorTime < time) {
                setErrorMessage("Please enter a time that hasn't passed");
                setEditorTime("");
                return;
            }
        }

        if(!editorTitle
            || !editorName
            || !editorTime
            || !editorLoc
            || !editorDes
            || !fileName) {
                if(!editorTitle) {
                    setMissingTitle(true);
                } else {
                    setMissingTitle(false);
                }
                if(!editorName){
                    setMissingDate(true);
                } else {
                    setMissingDate(false);
                }
                if(!editorTime){
                    setMissingTime(true);
                } else {
                    setMissingTime(false);
                }
                if(!editorLoc){
                    setMissingLoc(true);
                } else {
                    setMissingLoc(false);
                }
                if(!editorDes){
                    setMissingDes(true);
                } else {
                    setMissingDes(false);
                }
                if(!fileName){
                    setMissingFile(true);
                } else {
                    setMissingFile(false);
                }
                setMissingInfo(true);
                return;
        }

        const formData = new FormData();

        formData.append("articleImage", fileName);
        formData.append("name", editorName);
        formData.append("title", editorTitle);
        formData.append("time", editorTime);
        formData.append("location", editorLoc);
        formData.append("description", editorDes);
        formData.append("rsvpNum", editorNum);
        formData.append("vaxReq", editorVax);

        if(!editEventData) {
            try {
            await axios.post("https://link2rsvp.herokuapp.com/event/", formData);
            } catch (err) {
                if (err.response) {
                    
                        setErrorMessage(err.response.data.errorMessage);
                    
                }
            }
        }
        else {
            try{
            await axios.put(`https://link2rsvp.herokuapp.com/event/${editEventData._id}`, formData);
            } catch (err) {
                if (err.response) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }

        getEvent();

       closeEditor();
       close();
    }
    /**
     * clears event editor
     */
    function closeEditor() {
        setEventEditorOpen(true);
        setEditorName("");
        setEditorTitle("");
        setEditorTime("");
        setEditorLoc("");
        setEditorDes("");
        setEditorNum(0);
        setEditorVax("");
        setFile("");
        close();
    }

    


    return  (
    <div className="event-editor">

        {
            errorMessage && (
                <ErrorMessage
                message={errorMessage}
                clear={() => setErrorMessage(null)}
                />
            )
        }

    
    <form onSubmit={saveEvent} encType="multipart/form-data">

        <Form.Group className="mb=3">
        <Form.Label htmlFor="editor-title" className="editor">
            Title:
            {
                missingTitle && (
                    <span style={{color: "red",fontSize: "15pt"}}>*</span>
                )
            }
        </Form.Label>
        <Form.Control 
        id="editor-title"
        type="text"
        pattern="[A-Za-z0-9\s']+"
        title="please use a-z, A-z, and 0-9"
        maxLength="50"
        value={editorTitle}
        onChange={(e) => setEditorTitle(e.target.value)}
            />
        </Form.Group>
        <Row>
            <Col>
        <Form.Group className="mb-3">
        <Form.Label htmlFor="editor-name" className="editor">
            Date:
            {
                missingDate && (
                    <span style={{color: "red",fontSize: "15pt"}}>*</span>
                )
            }
        </Form.Label>
        <Form.Control
        id="editor-name"
        type="date"
        max="2023-12-31"
        min={today}
        value={editorName}
        //required
        onChange={(e) => setEditorName(e.target.value)}
        />
        </Form.Group>
            </Col>
            <Col>
        <Form.Group className="mb-b">
        <Form.Label htmlFor="editor-time" className="editor">
            Time:
            {
                missingTime && (
                    <span style={{color: "red",fontSize: "15pt"}}>*</span>
                )
            }
        </Form.Label>
        <Form.Control
        id="editor-time"
        type="time"
        value={editorTime}
        //required
        onChange={(e) => setEditorTime(e.target.value)}
        />
        </Form.Group>
        </Col>
        </Row>
        <Form.Group>
        <Form.Label htmlFor="editor-loc" className="editor">
            Location:
            {
                missingLoc && (
                    <span style={{color: "red",fontSize: "15pt"}}>*</span>
                )
            }
        </Form.Label>
        <Form.Control
        id="editor-loc"
        type="text"
        maxLength="75"
        pattern="[A-Za-z0-9\s']+"
        title="please use a-z, A-z, and 0-9"
        value={editorLoc}
        //required
        onChange={(e) => setEditorLoc(e.target.value)}
        />
        </Form.Group>
        <Row>
            <Col>
        <Form.Group>
            <Form.Label htmlFor="editor-Num" className="editor">Occupancy Limit:</Form.Label>
            <Form.Control
            id="editor-Num"
            type="number"
            min="1"
            max="100"
            value={editorNum}
            //required
            onChange={(e) => setEditorNum(e.target.value)}
            />
        </Form.Group>
        </Col>
        <Col>
        
        <Form.Group>
            <Form.Label htmlFor="custom-switch" className="editor">Covid Vaccine required?</Form.Label>
            <Form.Check 
            type="switch"
            id="custom-switch"
            checked={editorVax}
            onChange={(e) => setEditorVax(e.target.checked)}
        />
        </Form.Group>
        </Col>
        </Row>
        <Form.Group>
        <Form.Label htmlFor="editor-des" className="editor">
            Description:
            {
                missingDes && (
                    <span style={{color: "red",fontSize: "15pt"}}>*</span>
                )
            }
        </Form.Label>
        <span>{desCount}/150</span>
        <Form.Control as="textarea" rows={2}
        id="editor-des"
        type="text"
        value={editorDes}
        maxLength="150"
        //required
        onChange={(e) => [setEditorDes(e.target.value),setDesCount(e.target.value.length)]}
        />
        </Form.Group>

        <Form.Group>
            <Form.Label htmlFor="file" className="editor">
                Choose an image: 
                {
                missingFile && (
                    <span style={{color: "red",fontSize: "15pt"}}>*</span>
                )
            }
            </Form.Label>
            <br></br>
            <input
            id="image"
            value={images}
            type="file"
            name="articleImage"
            accpet="image/x-png,image/gif,image/jpeg,image/jpg"
            className="form-control-file"
            //required
            onChange={onChangeFile}
            />
        </Form.Group> <br></br>

        {
            missingInfo && (
                <p style={{color: "red", fontSize: "15pt", textAlign: "center"}}>Please fill out all required Fields *</p>
            )
        }

        <Button type="submit" variant="secondary" id="add-btn" style={{backgroundColor: "#890E32"}}> Add Event</Button>
        <Button type="button" variant="Dark" onClick={closeEditor} id="cancel-btn" style={{backgroundColor: "black", color: "white"}}>Cancel</Button>
    </form>
        
</div>
    );
};

export default EventEditor;